import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useOrdersBrandNodes } from "../brand/nodes/orders/useOrdersBrandNodes";
import { useExclusivityBrandNodes } from "../brand/nodes/useExclusivityBrandNodes";
import { useFaireDirectBrandNodes } from "../brand/nodes/useFaireDirectBrandNodes";
import { useHowFaireWorksBrandNodes } from "../brand/nodes/useHowFaireWorksBrandNodes";
import { useIntegrationsBrandNodes } from "../brand/nodes/useIntegrationsBrandNodes";
import { useMyAccountBrandNodes } from "../brand/nodes/useMyAccountBrandNodes";
import { useMyCatalogBrandNodes } from "../brand/nodes/useMyCatalogBrandNodes";
import { useMyShopBrandNodes } from "../brand/nodes/useMyShopBrandNodes";
import { usePaymentsBrandNodes } from "../brand/nodes/usePaymentsBrandNodes";
import { useShippingBrandNodes } from "../brand/nodes/useShippingBrandNodes";
export var useBrandNodes = function useBrandNodes() {
  var ORDERS_NODES = useOrdersBrandNodes();
  var SHIPPING_NODES = useShippingBrandNodes();
  var MY_ACCOUNT_NODES = useMyAccountBrandNodes();
  var PAYMENTS_NODES = usePaymentsBrandNodes();
  var MY_SHOP_NODES = useMyShopBrandNodes();
  var MY_CATALOG_NODES = useMyCatalogBrandNodes();
  var INTEGRATIONS_NODES = useIntegrationsBrandNodes();
  var FAIRE_DIRECT_NODES = useFaireDirectBrandNodes();
  var EXCLUSIVITY_NODES = useExclusivityBrandNodes();
  var HOW_FAIRE_WORKS_NODES = useHowFaireWorksBrandNodes();
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    Root: {
      id: "Root",
      children: ["Orders", "Shipping", "MyAccount", "Payments", "MyShop", "MyCatalog", "Integrations", "FaireDirect", "Exclusivity", "HowFaireWorks"],
      level: 0
    }
  }, ORDERS_NODES), SHIPPING_NODES), MY_ACCOUNT_NODES), PAYMENTS_NODES), MY_SHOP_NODES), MY_CATALOG_NODES), INTEGRATIONS_NODES), FAIRE_DIRECT_NODES), EXCLUSIVITY_NODES), HOW_FAIRE_WORKS_NODES);
};